import i18n from 'i18n';


const tableLanguage = {
  andCondition: i18n.t('andCondition'),
  orCondition: i18n.t('orCondition'),
  selectAll: i18n.t('selectAll'),
  selectAllSearchResults: i18n.t('selectAllSearchResults'),
  searchOoo: i18n.t('searchOoo'),
  blanks: i18n.t('blanks'),
  noMatches: i18n.t('noMatches'),

  // Number Filter & Text Filter
  filterOoo: i18n.t('filterOoo'),
  equals: i18n.t('equals'),
  notEqual: i18n.t('notEqual'),
  blank: i18n.t('blank'),
  notBlank: i18n.t('notBlank'),
  empty: i18n.t('empty'),

  // Number Filter
  lessThan: i18n.t('lessThan'),
  greaterThan: i18n.t('greaterThan'),
  lessThanOrEqual: i18n.t('lessThanOrEqual'),
  greaterThanOrEqual: i18n.t('greaterThanOrEqual'),
  inRange: i18n.t('inRange'),
  inRangeStart: i18n.t('inRangeStart'),
  inRangeEnd: i18n.t('inRangeEnd'),

  // Text Filter
  contains: i18n.t('contains'),
  notContains: i18n.t('notContains'),
  startsWith: i18n.t('startsWith'),
  endsWith: i18n.t('endsWith'),

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  //andCondition: i18n.t('andCondition'),
  //orCondition: i18n.t('orCondition'),

  // Filter Buttons
  //applyFilter: i18n.t('applyFilter'),
  //resetFilter: i18n.t('resetFilter'),
  clearFilter: i18n.t('clearFilter'),
  cancelFilter: i18n.t('cancelFilter'),

  // Filter Titles
  textFilter: i18n.t('textFilter'),
  numberFilter: i18n.t('numberFilter'),
  dateFilter: i18n.t('dateFilter'),
  setFilter: i18n.t('setFilter'),

  // Side Bar
  columns: i18n.t('columns'),
  filters: i18n.t('filters'),

  // columns tool panel
  pivotMode: i18n.t('pivotMode'),
  groups: i18n.t('groups'),
  rowGroupColumnsEmptyMessage: i18n.t('rowGroupColumnsEmptyMessage'),
  values: i18n.t('selectAll'),
  valueColumnsEmptyMessage: i18n.t('valueColumnsEmptyMessage'),
  pivots: i18n.t('pivots'),
  pivotColumnsEmptyMessage: i18n.t('pivotColumnsEmptyMessage'),
 
  pinColumn: i18n.t('pinColumn'),
  pinLeft: i18n.t('pinLeft'),
  pinRight: i18n.t('pinRight'),
  noPin: i18n.t('noPin'),
  valueAggregation: i18n.t('valueAggregation'),
  autosizeThiscolumn: i18n.t('autosizeThiscolumn'),
  autosizeAllColumns: i18n.t('autosizeAllColumns'),
  groupBy: i18n.t('groupBy'),
  ungroupBy: i18n.t('ungroupBy'),
  resetColumns: i18n.t('resetColumns'),
  expandAll: i18n.t('expandAll'),
  collapseAll: i18n.t('collapseAll'),
  copyWithHeaders: i18n.t('copyWithHeaders'),
  copyWithGroupHeaders: i18n.t('copyWithGroupHeaders'),
  export: i18n.t('export'),
  csvExport: i18n.t('exportCsv'),
  excelExport: i18n.t('exportExcel'),
  applyFilter: i18n.t('apply'),
  resetFilter: i18n.t('reset'),
}


  
export { tableLanguage };
  